export default __webpack_public_path__ + "0793f4732408b0b6c105d4ec4ca9fdd1.png";